<div [ngClass]="customClass">
  @if (label.length > 1) {
    <app-cab-label [for]="id" [label]="label" [required]="required" />
  }
  <p-calendar
    [minDate]="minDate"
    [maxDate]="maxDate"
    [readonlyInput]="readonly"
    [className]="readonly ? 'readonly' : ''"
    [iconDisplay]="iconDisplay ? 'input' : 'button'"
    [placeholder]="placeholder | translate"
    [showTime]="showTime"
    [timeOnly]="timeOnly"
    [touchUI]="touchUI"
    [hourFormat]="hourFormat"
    [view]="view"
    [dateFormat]="dateFormat"
    [showIcon]="showIcon"
    [style]="styleCalendar"
    [disabled]="disabled"
    [selectionMode]="selectionMode"
    (onSelect)="onDateSelect($event)"
    (onInput)="onDateInput($event)"
    [(ngModel)]="value"
    [showClear]="clearable"
    (onClear)="onClear()"
  />
</div>
